import { render, staticRenderFns } from "./data41.vue?vue&type=template&id=54f97347&scoped=true"
import script from "./data41.vue?vue&type=script&lang=js"
export * from "./data41.vue?vue&type=script&lang=js"
import style1 from "./data41.vue?vue&type=style&index=1&id=54f97347&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f97347",
  null
  
)

export default component.exports